var _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBareMetal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1663 18.3334H5.83301C4.45217 18.3334 3.33301 17.2142 3.33301 15.8334V4.16669C3.33301 2.78585 4.45217 1.66669 5.83301 1.66669H14.1663C15.5472 1.66669 16.6663 2.78585 16.6663 4.16669V15.8334C16.6663 17.2142 15.5472 18.3334 14.1663 18.3334Z",
    fill: "#C4C4C4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99967 16.6666C10.9201 16.6666 11.6663 15.9205 11.6663 15C11.6663 14.0795 10.9201 13.3333 9.99967 13.3333C9.0792 13.3333 8.33301 14.0795 8.33301 15C8.33301 15.9205 9.0792 16.6666 9.99967 16.6666Z",
    fill: "url(#paint0_linear_5698_7236)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.333 6.66669H6.66634C6.20634 6.66669 5.83301 6.29335 5.83301 5.83335V5.00002C5.83301 4.54002 6.20634 4.16669 6.66634 4.16669H13.333C13.793 4.16669 14.1663 4.54002 14.1663 5.00002V5.83335C14.1663 6.29335 13.793 6.66669 13.333 6.66669Z",
    fill: "url(#paint1_linear_5698_7236)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.333 10.8333H6.66634C6.20634 10.8333 5.83301 10.46 5.83301 9.99998V9.16665C5.83301 8.70665 6.20634 8.33331 6.66634 8.33331H13.333C13.793 8.33331 14.1663 8.70665 14.1663 9.16665V9.99998C14.1663 10.46 13.793 10.8333 13.333 10.8333Z",
    fill: "url(#paint2_linear_5698_7236)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5698_7236",
    x1: 9.99967,
    y1: 13.3333,
    x2: 9.99967,
    y2: 16.6666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ACACAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#707070"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5698_7236",
    x1: 9.99967,
    y1: 4.16669,
    x2: 9.99967,
    y2: 6.66669,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ACACAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#707070"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5698_7236",
    x1: 9.99967,
    y1: 8.33331,
    x2: 9.99967,
    y2: 10.8333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ACACAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#707070"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBareMetal);
export default __webpack_public_path__ + "static/media/bare-metal.979cfa95e1467c71cdde4a948c902c70.svg";
export { ForwardRef as ReactComponent };